export const profileActionTypes = {
    SET_PROFILES: 'SET_PROFILES',
    SET_AVAILABLE_PERMISSIONS: 'SET_AVAILABLE_PERMISSIONS',
};